import SideMenu from '@/containers/side-menu/SideMenu.vue';
import AccountingCashReport from '@/pages/accounting-cash-report/AccountingCashReport.vue';

export default {
  path: '/accounting-cash-report',
  name: 'AccountingCashReport',
  components: {
    mainContent: AccountingCashReport,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'accounting-cash-report',
    },
    breadcrumb: {
      title: 'Controle de caixa',
      paths: [{ title: 'Controle de caixa' }, { title: 'Relatório' }],
    },
  },
};
